import { render } from "./WatchVariants.vue?vue&type=template&id=b998435c&scoped=true"
import script from "./WatchVariants.vue?vue&type=script&lang=js"
export * from "./WatchVariants.vue?vue&type=script&lang=js"

import "./WatchVariants.vue?vue&type=style&index=0&id=b998435c&lang=css"
import "./WatchVariants.vue?vue&type=style&index=1&id=b998435c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b998435c"]])

export default __exports__